import { Component } from 'react';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import { clearAuthState } from 'utils/auth';

class ChangePasswordSubscription extends Component {
  constructor(props) {
    super(props);
    this.changePasswordSubscription = null;
  }

  componentDidMount() {
    this.subscribeToChangePasswordLogout();
  }

  componentWillUnmount() {
    if (this.changePasswordSubscription) {
      this.changePasswordSubscription.unsubscribe();
      this.changePasswordSubscription = null;
    }
  }

  subscribeToChangePasswordLogout() {
    if (this.changePasswordSubscription) {
      this.changePasswordSubscription.unsubscribe();
    }
    this.changePasswordSubscription = this.props.client
      .subscribe({
        query: SUBSCRIPTION_CHANGE_PASSWORD_LOGOUT
      })
      .subscribe({
        next(subscriptionData) {
          if (subscriptionData) {
            clearAuthState('/login');
          }
        },
        error(err) {
          console.error('Error in userPasswordChanged: ', err);
        }
      });
  }

  render() {
    return null;
  }
}

const SUBSCRIPTION_CHANGE_PASSWORD_LOGOUT = gql`
  subscription {
    userPasswordChanged {
      logoutReason
      userId
    }
  }
`;

export default withApollo(ChangePasswordSubscription);
